module.exports = __webpack_public_path__ + "img/electron_login_bg_1.09ceb946.png";